import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/useAuthStore';

export default function AdminRoute({ children }) {
  const { user } = useAuthStore();
  if (!user || user.role !== 'admin') return <Navigate to="/admin/login" replace />;
  return children;
}
